export const PlyFormat = {
    'INRIAV1': 0,
    'INRIAV2': 1,
    'PlayCanvasCompressed': 2
};
